
import { defineComponent, provide } from 'vue'
import { Device, Env } from '@loca/mfe-vue3'
import Layout from '@/components/Layout/index.vue'
import { Toast } from 'vant'
import './styles/global.scss'

// 初始化语言包 & 版本
const lang = Env.getLang()
const appType = Env.getAppType()
const container = window.appSystemInfo?.container || 'browser'

document.body.setAttribute('lang', lang)
document.body.setAttribute('data-app-type', appType)
document.body.setAttribute('data-container', container)

export default defineComponent({
  name: 'AppRootPage',

  components: { Layout },

  computed: {
    isMicroApp() {
      const { isMicroApp } = this.$route.meta || {}
      return typeof isMicroApp === 'boolean' ? isMicroApp : false
    },
    is500Page() {
      return this.$route && this.$route.path === '/500'
    },
    isMobile() {
      Toast.clear()
      return Device.isMobile()
    },
  },

  setup() {
    provide('isMobile', Device.isMobile())
    provide('appInfo', { lang, appType })
  }
})
